// extracted by mini-css-extract-plugin
var _1 = "tjs-chart-preview__chart-td";
var _2 = "tjs-chart-preview__chart-title-from-table";
var _3 = "tjs-chart-preview__chart-td";
var _4 = "tjs-chart-preview__chart-title-from-table";
var _5 = "tjs-chart-preview__preview-chart";
var _6 = "tjs-chart-preview__preview-chart-wrapper";
var _7 = "tjs-chart-preview__preview-chart";
var _8 = "tjs-chart-preview__preview-chart-wrapper";
export { _1 as "chart-td", _2 as "chart-title-from-table", _3 as "chartTd", _4 as "chartTitleFromTable", _5 as "preview-chart", _6 as "preview-chart-wrapper", _7 as "previewChart", _8 as "previewChartWrapper" }
export default { "chart-td": _1, "chart-title-from-table": _2, "chartTd": _3, "chartTitleFromTable": _4, "preview-chart": _5, "preview-chart-wrapper": _6, "previewChart": _7, "previewChartWrapper": _8 }
